module.exports = __webpack_public_path__ + "assets/4d81b881f18584fb49c3caa24579e4bf.mp3";